/* Buttons, switches, inputs and the shortcut grid used inside modals. */

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 46px;
  padding: 0 20px;
  border-radius: 14px;
  font-size: 15.5px;
  font-weight: 620;
  letter-spacing: -0.015em;
  width: 100%;
  transition:
    transform 0.2s var(--ease),
    filter 0.2s;
}

.btn:active {
  transform: scale(0.97);
}

.btn svg {
  width: 19px;
  height: 19px;
}

.primary {
  background: linear-gradient(180deg, var(--accent), var(--accent-deep));
  color: #fff;
  box-shadow:
    0 3px 12px var(--accent-glow),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.quiet {
  background: rgba(255, 255, 255, 0.66);
  color: var(--ink);
  box-shadow: inset 0 0 0 0.5px rgba(11, 31, 23, 0.08);
  margin-top: 10px;
}

.keys {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(215px, 1fr));
  gap: 2px 18px;
}

.keyrow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 7px 0;
  box-shadow: 0 0.5px 0 rgba(11, 31, 23, 0.05);
}

.keyrow span {
  font-size: 13.5px;
}

.keyrow kbd {
  font-family: var(--font);
  font-size: 11.5px;
  font-weight: 650;
  min-width: 24px;
  text-align: center;
  padding: 3px 7px;
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.8);
  color: var(--ink);
  box-shadow:
    inset 0 0 0 0.5px rgba(11, 31, 23, 0.12),
    0 1px 1px rgba(11, 31, 23, 0.06);
}

.input {
  width: 100%;
  height: 44px;
  padding: 0 13px;
  border-radius: 12px;
  border: 0;
  outline: none;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: inset 0 0 0 0.5px rgba(11, 31, 23, 0.1);
  font-family: var(--mono);
  font-size: 13px;
  color: var(--ink);
  margin-bottom: 10px;
}

.input:focus {
  box-shadow: inset 0 0 0 1.5px var(--accent);
}

.hint {
  font-size: 12.5px;
  color: var(--ink-3);
  margin: -4px 0 14px;
}

.toggleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 11px 0;
  box-shadow: 0 0.5px 0 rgba(11, 31, 23, 0.05);
}

.toggleTitle {
  font-size: 14.5px;
  color: var(--ink);
  font-weight: 550;
}

.toggleSub {
  font-size: 12.5px;
  color: var(--ink-3);
  margin-top: 1px;
}

.switch {
  width: 51px;
  height: 31px;
  border-radius: 999px;
  background: rgba(11, 31, 23, 0.14);
  position: relative;
  flex: none;
  transition: background 0.3s var(--ease);
}

.switch::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 27px;
  height: 27px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 5px rgba(16, 48, 34, 0.22);
  transition: transform 0.32s var(--ease);
}

.switchOn {
  background: var(--accent);
}

.switchOn::after {
  transform: translateX(20px);
}

/* The build line under About: present, quiet, and not competing with prose. */
.build {
  font-size: 12.5px;
  color: var(--ink-3);
  margin: -4px 0 12px;
}

.build a {
  color: inherit;
  text-decoration-color: rgba(11, 31, 23, 0.25);
  text-underline-offset: 2px;
}

.build a:hover {
  color: var(--ink);
}

.build code {
  font-family: var(--mono);
  font-size: 12px;
}
